/**
 * @typedef ChatPrompt
 *
 * @property {string}   _id
 *
 * @property {string}   group
 * @property {string}   index
 *
 * @property {string}   query
 * @property {string}   reply
 *
 * @property {boolean}  isEnabled
 *
 * @property {string}   createdAt
 */

/**
 * @param {ChatPrompt|undefined} prompt
 * @returns {ChatPrompt}
 */
export function initChatPrompt(prompt = {}) {
    return {
        ...(prompt || {}),

        group: prompt?.group ?? null,
        index: prompt?.index ?? null,

        query: prompt?.query ?? null,
        reply: prompt?.reply ?? null,

        isEnabled: prompt?.isEnabled ?? false,
    };
}
